//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TeamMemberDesComponent",
  data() {
    const _this = this;
    return {
      memberDes: [
        _this.$t("inviteMemberPage.des1"),
        _this.$t("inviteMemberPage.des2"),
        _this.$t("inviteMemberPage.des3"),
        "You or member can review and approve the schedules before they get posted.",
      ],
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/team_member/des/Index.vue